import { useQueryStateContext } from 'modules/queryBuilder/contexts';
import { isCatalogESIndex } from '../utils';

export const useIsCatalogESIndex = () => {
  const state = useQueryStateContext();
  return isCatalogESIndex(state);
};
